import React, { useState, useRef, useEffect } from "react";
import {
  Row,
  Col,
  Card,
  CardBody,
  CardHeader,
  Form,
  FormGroup,
  Label,
  Input,
  Button,
} from "reactstrap";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import swal from "sweetalert2";
import { handleError } from "@/util/errorHandler";

import users from "@/api/users";

// import MerchantsTable from "../Components/MerchantsTable";
import TableContainerWithLocation from "../Components/TableContainerWithLocation";
import EditUserModal from "../Components/EditUserModal";

const headerStyle = {
  backgroundColor: "#D15050",
  color: "white",
};

const marginRight = {
  marginRight: "8px",
};

function Users(props) {
  const table = useRef(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);

  const loadPagination = async (page = 0, size = 10, search, sort) => {
    let result = await users.getUsers(page, size, search, sort);
    return result;
  };

  const refreshTable = () => {
    table.current && table.current.loadAndStoreData();
  };

  const editUser = user => {
    setSelectedUser(user);
    toggleModal();
  };

  const blockUser = user => {
    return swal({
      title: "Are you sure?",
      text: "Do you want to block this user?",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Block",
      cancelButtonText: "Cancel",
      reverseButtons: true,
    }).then(result => {
      if (result.value)
        return users
          .blockUser(user.id)
          .then(() => {
            swal("Success", "User blocked", "success");
            refreshTable();
          })
          .catch(handleError);
    });
  };

  const toggleModal = () => {
    isModalOpen && refreshTable();
    selectedUser && setSelectedUser(null);
    setIsModalOpen(!isModalOpen);
  };

  const actionsFormatter = (cell, row, type) => {
    const { id, login } = row;

    return row.activated ? (
      <>
        <Button style={marginRight} type="button" onClick={() => editUser(row)}>
          Edit
        </Button>
        <Button type="button" color="primary" onClick={() => blockUser(row)}>
          Block
        </Button>
      </>
    ) : (
      ""
    );
  };

  const blockedFormatter = (cell, row) => {
    return <>{row.activated ? "" : "Blocked"}</>;
  };

  return (
    <>
      <div className="animated fadeIn">
        <Row>
          <Col>
            <Card>
              <CardHeader>Users</CardHeader>
              <CardBody>
                <Form
                  inline
                  style={{
                    marginBottom: ".5rem",
                    justifyContent: "flex-end",
                  }}>
                  <FormGroup>
                    <Button
                      color="success"
                      type="button"
                      onClick={() => editUser({})}>
                      Add user
                    </Button>
                  </FormGroup>
                </Form>
                <TableContainerWithLocation
                  loadData={loadPagination}
                  wrappedComponentRef={innerComponent => {
                    if (innerComponent) {
                      table.current = innerComponent;
                    }
                  }}>
                  <BootstrapTable
                    headerStyle={headerStyle}
                    version="4"
                    search
                    pagination
                    striped
                    hover
                    condensed
                    remote>
                    <TableHeaderColumn dataSort width="200" dataField="login">
                      Login
                    </TableHeaderColumn>
                    <TableHeaderColumn
                      dataSort
                      width="200"
                      dataField="firstName">
                      First name
                    </TableHeaderColumn>
                    <TableHeaderColumn
                      dataSort
                      width="200"
                      dataField="lastName">
                      Last name
                    </TableHeaderColumn>
                    <TableHeaderColumn
                      dataSort
                      width="100"
                      dataField="activated"
                      dataFormat={(cell, row) => blockedFormatter(cell, row)}>
                      Blocked
                    </TableHeaderColumn>
                    <TableHeaderColumn
                      isKey
                      width="120"
                      dataField="id"
                      dataFormat={(cell, row) => actionsFormatter(cell, row)}>
                      Actions
                    </TableHeaderColumn>
                  </BootstrapTable>
                </TableContainerWithLocation>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>

      {selectedUser && (
        <EditUserModal
          isOpen={isModalOpen}
          onModalClose={toggleModal}
          user={selectedUser}
          addNew
        />
      )}
    </>
  );
}

export default Users;
